import { PatientTreatmentPhases } from "@/constants/User";

/** Support has "You" selected and at least one linked patient is in treatment. */
const isSupportViewingSelfWithLinkedPatientInTreatment = ({
  appUserId,
  hasLinkedPatientInTreatment,
  isAppUserPatient,
  selectedUserId,
}: {
  appUserId: string;
  hasLinkedPatientInTreatment: boolean;
  isAppUserPatient: boolean;
  selectedUserId: string;
}): boolean =>
  !isAppUserPatient &&
  selectedUserId === appUserId &&
  hasLinkedPatientInTreatment;

export const getIsSelectedUserInTreatmentForBooking = ({
  appUserId,
  hasLinkedPatientInTreatment,
  isAppUserInTreatment,
  isAppUserPatient,
  selectedUserId,
  selectedUserPhase,
}: {
  appUserId: string;
  hasLinkedPatientInTreatment: boolean;
  isAppUserInTreatment: boolean;
  isAppUserPatient: boolean;
  selectedUserId: string;
  selectedUserPhase?: TreatmentPhase;
}): boolean =>
  (isAppUserPatient && isAppUserInTreatment) ||
  (!isAppUserPatient &&
    selectedUserPhase === PatientTreatmentPhases.InTreatment) ||
  isSupportViewingSelfWithLinkedPatientInTreatment({
    appUserId,
    hasLinkedPatientInTreatment,
    isAppUserPatient,
    selectedUserId,
  });
